import * as React from 'react';
import * as styles from './styles.scss';
import { checkNetworkConnectionText } from './NetworkError.locstring.json';
import HighContrast_illustration_errorSvg from 'owa-empty-state/lib/svg/HighContrast/illustration_error.svg';
import Light_illustration_errorSvg from 'owa-empty-state/lib/svg/Light/illustration_error.svg';
import Dark_illustration_errorSvg from 'owa-empty-state/lib/svg/Dark/illustration_error.svg';
import DarkTheme_illustration_errorSvg from 'owa-empty-state/lib/svg/DarkTheme/illustration_error.svg';
import LightTheme_illustration_errorSvg from 'owa-empty-state/lib/svg/LightTheme/illustration_error.svg';
import { getIsMsHighContrast } from 'owa-high-contrast';
import { getIsLightBaseTheme, getIsDarkBaseTheme } from 'owa-theme';
import { getIsDarkTheme } from 'owa-fabric-theme';
import { observer } from 'mobx-react-lite';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import { retryButtonText } from 'owa-locstrings/lib/strings/retrybuttontext.locstring.json';
import { cancelButton } from 'owa-locstrings/lib/strings/cancelbutton.locstring.json';
import loc from 'owa-localize';
import { logUsage } from 'owa-analytics';

export default observer(function NetworkError({
    errorMessage,
    onRetry,
    onCancel,
}: {
    errorMessage?: string;
    onRetry?: () => void;
    onCancel?: () => void;
}) {
    React.useEffect(() => {
        // this should be captured by looking at DefaultBoardLoadState dp for error load states, but adding this for confidence that we're capturing all hits
        // this should be removed when we are confident moca and board telemetry are merged and DefaultBoardLoadState should't have future changes
        logUsage('TimestreamNetworkError');
    }, []);

    // Need these callbacks to ensure onRetry/onCancel are called without the event source argument.
    const retryCallback = React.useCallback(() => {
        onRetry?.();
    }, [onRetry]);

    const cancelCallback = React.useCallback(() => {
        onCancel?.();
    }, [onCancel]);

    return (
        <div className={styles.centered}>
            <img
                style={{ width: '120px', height: '120px' }}
                src={getNetworkErrorImageSrc()}
                alt=""
            />
            <div className={styles.errorReport}>{errorMessage}</div>
            <div className={styles.checkNetworkConnection}>{loc(checkNetworkConnectionText)}</div>
            <div className={styles.buttons}>
                {onRetry && (
                    <PrimaryButton className={styles.button} onClick={retryCallback}>
                        {loc(retryButtonText)}
                    </PrimaryButton>
                )}
                {onCancel && (
                    <DefaultButton className={styles.button} onClick={cancelCallback}>
                        {loc(cancelButton)}
                    </DefaultButton>
                )}
            </div>
        </div>
    );
});

function getNetworkErrorImageSrc(): string {
    if (getIsMsHighContrast()) {
        return HighContrast_illustration_errorSvg;
    } else if (getIsLightBaseTheme()) {
        return Light_illustration_errorSvg;
    } else if (getIsDarkBaseTheme()) {
        return Dark_illustration_errorSvg;
    } else if (getIsDarkTheme()) {
        return DarkTheme_illustration_errorSvg;
    } else {
        return LightTheme_illustration_errorSvg;
    }
}
